import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({ providedIn: "root" })
export class ProcessingLogService {
  constructor(private http: HttpClient) {}

  getProcessingLogById(id): Observable<any> {
    return this.http.get(
      `${environment.apiBaseAddress}ProcessingLog/${id}`,
      httpOptions
    );
  }

  filterProcessingLogs(filter): Observable<any> {
    return this.http.post(
      `${environment.apiBaseAddress}ProcessingLog/Filter`,
      filter,
      httpOptions
    );
  }

  getUnreadCount(): Observable<any> {
    return this.http.get(
      `${environment.apiBaseAddress}ProcessingLog/Unread/Count`,
      httpOptions
    );
  }

  markAsRead(id): Observable<any> {
    return this.http.put(
      `${environment.apiBaseAddress}ProcessingLog/${id}/Read`,
      {},
      httpOptions
    );
  }

  markAllAsRead(): Observable<any> {
    return this.http.put(
      `${environment.apiBaseAddress}ProcessingLog/Read/All`,
      {},
      httpOptions
    );
  }
}
